import { ProductFlagService } from '../../ProductFlag.service';
import { getProductFlagValues } from '../../../client/js/main/selectors/ProductSelectors';
import { DimensionProductMapping, DimensionToProductsMapType } from './DimensionProductMapping';

import { ProductFlagValues } from '../../ProductFlipperFlag.service';

export class DimensionClassifier {
  constructor(
    private dimensionProductMapping: DimensionToProductsMapType = DimensionProductMapping,
    private productFlagService: ProductFlagService = new ProductFlagService()
  ) {}

  /**
   * Determines whether a dimension is provisioned based on product flags and conditions.
   *
   * @param {string} dimension - The dimension to check.
   * @returns {boolean} - Returns true if the dimension is provisioned, otherwise false.
   */
  public isProvisioned(dimension: string): boolean {
    const entry = this.dimensionProductMapping.get(dimension);
    if (!entry || !entry.enabled) {
      return false;
    }

    const productFlags: ProductFlagValues = getProductFlagValues();

    return entry.condition(productFlags);
  }
}
